<template>
    <div class="text-center">
      <v-dialog
        v-model="show"
        width="500"
      >
        <v-card>
          <v-card-title class="text-h2 grey lighten-2">
            <h2>{{titleDialog}}</h2> 
          </v-card-title>
  
          <v-card-text>
            {{textDialog}}
          </v-card-text>
  
          <v-divider></v-divider>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.stop="show=false">Atras</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>

  <script >
export default {
  props: {
     value: Boolean,
     textDialog:String,
     titleDialog:String
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
         this.$emit('input', value)
      }
    }
  }
}
  </script>